module.exports = __webpack_public_path__ + "fonts/PingFang SC Regular.8d76ff86.ttf";